var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.025,
    height: 54.039,
    viewBox: "0 0 54.025 54.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M57.891,54.62,42.866,39.454a21.413,21.413,0,1,0-3.25,3.292L54.543,57.814a2.312,2.312,0,0,0,3.264.084A2.328,2.328,0,0,0,57.891,54.62ZM26.039,42.929A16.908,16.908,0,1,1,38,37.977,16.8,16.8,0,0,1,26.039,42.929Z",
    transform: "translate(-4.5 -4.493)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuchen);
export default __webpack_public_path__ + "static/media/icon-suchen.6677548e.svg";
export { ForwardRef as ReactComponent };